import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import RouteTypes from '../../utils/routes/route_types';
import {
    InsSuperAdminRoute,
    BranchAdminRoute,
    LevelOneAdminRoute,
    LevelTwoAdminRoute,
} from '../../utils/routes/custom_routes';

/**
 * @inheritdoc
 */
class Routes extends Component {
    constructor(props) {
        super(props);
        this.renderRoutes = this.renderRoutes.bind(this);
    }

    renderRoutes = (routes) => {
        return routes.map((route, index) => {
            return route.roleType === RouteTypes.INS_SUPER_ADMIN ? (
                //   super admin route
                <InsSuperAdminRoute key={index} exact {...route} />
            ) : route.roleType === RouteTypes.BRANCH_ADMIN ? (
                //   branch admin route
                <BranchAdminRoute key={index} exact {...route} />
            ) : route.roleType === RouteTypes.LEVEL_ONE_ADMIN ? (
                //   level one admin route
                <LevelOneAdminRoute key={index} exact {...route} />
            ) : route.roleType === RouteTypes.LEVEL_TWO_ADMIN ? (
                //   level two admin route
                <LevelTwoAdminRoute key={index} exact {...route} />
            ) : null;
        });
    };

    /**
     * @inheritdoc
     */
    render() {
        const { renderRoutes } = this;
        const { routes } = this.props;
        return <Switch>{renderRoutes(routes)}</Switch>;
    }
}

export default Routes;
